import { useNavigate, useSearchParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useEffect } from 'react';

const useControllerNumberPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const formMethods = useForm();

  const handleOnSubmit = (data: any) => {
    if (data.phone.length >= 10) {
      const ddd = data.phone.slice(0, 2);
      const sufix = data.phone.slice(2);
      navigate(`/recarga/operadoras?ddd=${ddd}&phone=${sufix}`);
    }
  };

  useEffect(() => {
    const ddd = searchParams.get('ddd') || '';
    const phone = searchParams.get('phone') || '';
    if (ddd && phone) {
      formMethods.setValue('phone', `${ddd}${phone}`);
    }
  }, [formMethods, searchParams]);

  return {
    formMethods,
    handleOnSubmit
  };
};

export default useControllerNumberPage;
